"use strict";

var _attachments = require("libs/utils/attachments");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
module.exports =
/*#__PURE__*/
/* @ngInject */
function () {
  AssetEssencePreviewCtr.$inject = ["$scope", "eventService", "model"];
  function AssetEssencePreviewCtr($scope, eventService, model) {
    _classCallCheck(this, AssetEssencePreviewCtr);
    $scope.$ctrl = this;
    this.event = eventService.getCurrentEvent();
    this.model = model;
  }
  _createClass(AssetEssencePreviewCtr, [{
    key: "getIdealAssetDownloadFilename",
    value: function getIdealAssetDownloadFilename(fpAssetPath) {
      return fpAssetPath.substring(fpAssetPath.indexOf('.') + 1, fpAssetPath.indexOf('/')) + fpAssetPath.substring(fpAssetPath.lastIndexOf('.'));
    }
  }, {
    key: "shouldShowImageAssetPreview",
    value: function shouldShowImageAssetPreview(model) {
      var contentType = this.getAssetAttachmentContentType(model);
      var t = contentType.substring(0, contentType.indexOf('/'));
      return t === 'image';
    }
  }, {
    key: "getAssetAttachmentContentType",
    value: function getAssetAttachmentContentType(model) {
      var attachmentsNames = (0, _attachments.getAttachmentNames)(model);
      return ((0, _attachments.getAttachmentMetadata)(model, attachmentsNames[0]) || {}).content_type;
    }
  }]);
  return AssetEssencePreviewCtr;
}();